import React from 'react';
import { useTranslation } from 'react-i18next';
import { MessageCircle, Mail } from 'lucide-react';

export default function Support() {
  const { t } = useTranslation('support');

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <div className="text-center mb-12">
        <MessageCircle className="w-12 h-12 mx-auto text-blue-500 mb-4" />
        <h1 className="text-4xl font-bold text-gray-900 mb-4">{t('title')}</h1>
        <p className="text-lg text-gray-600">{t('subtitle')}</p>
      </div>

      <div className="grid gap-8 md:grid-cols-2 mb-12">
        <div className="bg-white p-6 rounded-xl border">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('commonIssues.title')}</h2>
          <ul className="space-y-4 text-gray-600">
            <li>
              <h3 className="font-medium">{t('commonIssues.expiration.title')}</h3>
              <p className="text-sm">{t('commonIssues.expiration.description')}</p>
            </li>
            <li>
              <h3 className="font-medium">{t('commonIssues.password.title')}</h3>
              <p className="text-sm">{t('commonIssues.password.description')}</p>
            </li>
            <li>
              <h3 className="font-medium">{t('commonIssues.rateLimit.title')}</h3>
              <p className="text-sm">{t('commonIssues.rateLimit.description')}</p>
            </li>
          </ul>
        </div>

        <div className="bg-white p-6 rounded-xl border">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('securityTips.title')}</h2>
          <ul className="space-y-4 text-gray-600">
            <li>
              <h3 className="font-medium">{t('securityTips.password.title')}</h3>
              <p className="text-sm">{t('securityTips.password.description')}</p>
            </li>
            <li>
              <h3 className="font-medium">{t('securityTips.expiration.title')}</h3>
              <p className="text-sm">{t('securityTips.expiration.description')}</p>
            </li>
            <li>
              <h3 className="font-medium">{t('securityTips.viewLimit.title')}</h3>
              <p className="text-sm">{t('securityTips.viewLimit.description')}</p>
            </li>
          </ul>
        </div>
      </div>

      <div className="bg-gray-50 p-8 rounded-xl border text-center">
        <Mail className="w-8 h-8 mx-auto text-blue-500 mb-4" />
        <h2 className="text-xl font-semibold text-gray-900 mb-2">{t('contact.title')}</h2>
        <p className="text-gray-600 mb-6">{t('contact.message')}</p>
        <a
          href="mailto:support@bitfortex.com"
          className="inline-flex items-center px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
        >
          {t('contact.button')}
        </a>
      </div>
    </div>
  );
}